/* -----------------------------------------------------------------
- Arena trans
----------------------------------------------------------------- */
export default {
    ref_no           : 'REF No.',
    truck_no         : 'Truck No.',
    order_user_search: 'نام کاربر',
    loading_place    : 'Place of loading',
};
